import "./RoofingContractors.module.css";
import Header from "@/reusable_sections/Header";
import RoofingHero from "./sections/RoofingHero";
import RoofingPartnership from "./sections/RoofingPartnership";
import Footer from "@/reusable_sections/Footer";
export default function RoofingContractorsPage() {
  return <div>
      <Header />
      <RoofingHero />
      <RoofingPartnership />
      <Footer />
    </div>;
}